import { z } from 'zod';

import type { Mutation } from './common';
import { skillShortSchema } from './skill';

type CertificateSkillIdField = {
    readonly skillId?: string | null;
};

export const certificateHistoryItemSchema = z.object({
    id: z.string(),
    acquiredDate: z.string().optional(),
    certificateName: z.string(),
    description: z.string().optional(),
    expiryDate: z.string().optional(),
    issuer: z.string().optional(),
    skill: skillShortSchema.nullable().optional(),
});

export const certificateHistoryItemArraySchema = certificateHistoryItemSchema.array();

export type CertificateHistoryItem = z.infer<typeof certificateHistoryItemSchema>;

export type CertificateHistoryCreation = CertificateSkillIdField & Omit<CertificateHistoryItem, 'id' | 'skill'>;
export type CertificateHistoryMutation = CertificateSkillIdField &
    Mutation<CertificateHistoryItem> &
    Pick<CertificateHistoryItem, 'certificateName' | 'id'>;
